export class Person {
  FirstName: string;
  Initials: string;
  Surname: string;
  MiddleName: string;
  Gender: string;
  DateOfBirth: Date;
  PlaceOfBirth: string;
  Email: string;
  RepeatEmail: string;
  Phone: string;
  PhoneWork: string;
  Mobile: string;
  Address: string;
  AddressNumber: string;
  PostalCode: string;
  City: string;
  CountryId: string;
  CourseId: number;
  Function: string;
  Iban: string;
  PriceCategory: string;
  UserField1 = 'True'; // Newsletter
  UserField2: string;
  UserField3: string;
  UserField4: string;
  UserField5: string;
  UserField6: string;
  UserField7: string;
  UserField8: string;
  UserField9: string;
  EnrolmentUserField1: string;
}
